import React from 'react';

import classNames from 'classnames/bind';
import style from './RightBanner.scss';
const ctx = classNames.bind(style);

const RightBanner = props => (
  <div className={ctx('limiter')}>
    <div className={ctx('banner')}>
      <div className={ctx('image-container')}>
        <div
          className={ctx('image')}
          style={{ backgroundImage: `url(${props.image})` }}
        />
      </div>
      <div className={ctx('text-container')}>
        <div className={ctx('text')}>
          {props.children}
          <div className={ctx('rectangle')} />
        </div>
      </div>
    </div>
  </div>
);

export default RightBanner;
